import { timezoneQuery, updateTimezoneMutation } from "../../api/graphql/queries/timezone";
import { FETCH_TIMEZONE, UPDATE_TIMEZONE } from "../actions/actionTypes";
import graphqlClient from "../../api/axios_interceptor";
import { updateActionErrors } from "../middleware/updateErrors";

const fetchTimezoneMiddleware = async (action) => {
  try {
    const queryResult = await graphqlClient({
      data: {
        query: timezoneQuery(action.payload),
      },
    });
    if (queryResult.data.errors) {
      action = updateActionErrors(action, queryResult.data.errors);
    } else {
      const result = queryResult.data.data;
      action = {
        ...action,
        payload: {
          ...action.payload,
          customerTimezone: result.customerTimezone
        }
      };
    }
  } catch (error) {
    console.error(error);
  }
  return action;
};

export const updateTimezoneMiddleware = async (action) => {
    try {
    const query = updateTimezoneMutation( action.payload.customerTimezone )
    await graphqlClient({
        data: { query }
    }).then( (queryResult) => {
      if (queryResult.data.errors) {
          action = updateActionErrors(action, queryResult.data.errors);
      } else if(queryResult.data.data.updateSettings.error){
          action = updateActionErrors(action,queryResult.data.data.updateSettings.error.message);
          action = {
              errorCode: queryResult.data.data.updateSettings.error.code,
              ...action
          }
      } else {
          action = ({
              ...action,
              payload: {
                  ...action.payload
              }
          });
      }
  })

}catch(error){
  console.log(error);
  action = updateActionErrors(action, error);
}
return action;
}

export const timezoneMiddleware = (api) => (next) => async (action) => {
  switch (action.type) {
    case FETCH_TIMEZONE:
        action = await fetchTimezoneMiddleware(action);
        break;
    case UPDATE_TIMEZONE:
        action =await updateTimezoneMiddleware(action);
        break;
    default:
        break;
  }
  return next(action);
};